import apiClient from '../api-client';
import type { Version, CreateVersionRequest, UpdateVersionRequest, PaginatedResponse, PaginationParams } from '@geely/shared';

export const versionsApi = {
  list: (modelId?: string) =>
    apiClient.get<Version[]>('/versions', {
      params: modelId ? { modelId } : undefined,
    }),

  listPaginated: (params: { modelId?: string } & PaginationParams) =>
    apiClient.get<PaginatedResponse<Version>>('/versions', { params }),

  getById: (id: string) =>
    apiClient.get<Version>(`/versions/${id}`),

  create: (data: CreateVersionRequest) =>
    apiClient.post<Version>('/versions', data),

  update: (id: string, data: UpdateVersionRequest) =>
    apiClient.patch<Version>(`/versions/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/versions/${id}`),
};
